export default __webpack_public_path__ + "static/media/no-results-light.30f29827.png";